<template lang="pug">
  #ReservationIndex
    h5.text-center.py-3.letter-spacing-6 我的預約
    b-row(
      no-gutters
      class="mb-3 button-row"
    )
      b-col(
        cols=4,
        class="button-item-first"
      )
        b-button(
          block,
          :variant=" nowSelect === 'reserving' ? 'primary selected' : 'light' ",
          @click="changeStatusHandler('reserving')"
        ) 申請預約
      b-col(
        cols=4
      )
        b-button(
          block,
          :variant=" nowSelect === 'checked' ? 'primary selected' : 'light' ",
          @click="changeStatusHandler('checked')"
        ) 完成預約
      b-col(
        cols=4
      )
        b-button(
          block,
          :variant=" nowSelect === 'success' ? 'primary selected' : 'light' ",
          @click="changeStatusHandler('success')"
        ) 到店諮詢

    b-row(
      no-gutters
      class="mb-3 button-row px-4"
    )
      b-col(
        cols=12
      )
        multiselect(
          v-model="selectType",
          placeholder="選擇預約狀態",
          selectLabel="已選擇預約狀態",
          :showLabels="false",
          selectedLabel="已選擇",
          label="title",
          track-by="id",
          :options="typeOption",
          :multiple="false",
          :taggable="false",
          :searchable="false",
          :allowEmpty="false",
          @select="changeStatusHandler"
          noOptions="無標籤"
        )
      template(slot="Label", slot-scope='{ tags }')
      template(slot="noOptions")
        strong 請按 Enter 新增標籤
    .bg-light
      .p-3.position-relative
        .row
          .col-10.d-flex.align-items-center
            p.mb-0 {{ nowSelect === 'reserving' ? '申請預約中' : nowSelect === 'checked' ? '確認預約' : nowSelect === 'success' ? '完成預約' : '-' }}筆數，總計{{ reservations.length }}筆
          .col-2
            .bg-white.rounded-circle.border.border-black.overflow-hidden.d-flex.align-items-center.justify-content-center(
              style="width: 40px;height: 40px;",
              @click="openScheduleModalHandler()"
            )
              b-img(
                :src="iconUrl.IconClendartUrl",
                fluid,
                width="25",
                height="25",
                alt="Icon"
              )
    b-card.border-0.mb-2.customerCard.overflow-hidden(
      bg-variant="light",
      v-for="(reservation,index) in reservations",
      :key="reservation.reservation_id",
      body-class="p-0"
    )
      .p-3.bg-primary
        .row.align-items-center.no-gutters.mb-3
          .col-3.pr-1
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="reservation.picture_url",
              :style="{ 'width': '70px', 'height': '70px' }"
            )
          .col-9.pl-1
            p.mb-0.font-weight-bold.text-17 {{ first_name(reservation) }}
            .row.no-gutters
              .col-6
                small 暱稱名：{{ reservation.line_name }}
              .col-6
                small 備註名：{{ reservation.note_name }}
              .col-12
                small ECM ID：{{ reservation.ecm_id }}
              .col-6
                small.mb-0 客戶TR：
                b-badge(
                  variant="white",
                  class="rounded-0 p-1 bg-white"
                ) {{ TRList.includes(reservation.level) ? reservation.level : '' }}
              .col-6
                small.mb-0 性別：
                b-badge(
                  variant="white",
                  class="rounded-0 p-1 bg-white"
                ) {{ genderList.includes(reservation.gender) ? reservation.gender : '' }}
        .row.align-items-center.no-gutters
          .col-6
            .d-flex.align-items-center
              i.fas.fa-birthday-cake.mr-2
              small 生日：{{ filterMonthToWord(reservation.birthday) }}
          .col-6
            small 上次到店資訊日期：{{ reservation.last_reserve_start_at }}
          .col-6
            .d-flex.align-items-center
              i.fas.fa-mobile-alt.mr-2
              small 電話：{{ reservation.mobile?reservation.mobile:reservation.reserve_mobile }}
          .col-6
            small 上次服務CA：{{ reservation.last_preferred_name }}
          .col-6
          .col-6
            small 上次交易CA：{{ reservation.tx_sp_name }}
      .p-3
        .row.align-items-center.no-gutters
          .col-6.mb-2
            .d-flex.align-items-center
              i.far.fa-calendar-check.mr-2
              small 預約日期：{{ reservation.reserve_date }}
          .col-6.mb-2
            .d-flex.align-items-center
              i.far.fa-clock.mr-2
              small(v-if="reservation.reserve_type_name !== null") 預約時間：{{ timeFormat(reservation.reserve_start_at) }}~{{ timeFormat(reservation.reserve_end_at) }} ({{reservation.site}})
              small(v-else-if="reservation.activity_name !== null") 預約時間：{{ timeFormat(reservation.reserve_start_at) }}~{{ timeFormat(reservation.reserve_end_at) }}
              small(v-else) 預約時間：
          .col-12.mb-2
            .d-flex.align-items-center
              i.far.fa-clipboard.mr-2
              small(v-if="reservation.reserve_type_name !== null") 服務內容：{{ reservation.reserve_type_name }}
              small(v-else-if="reservation.activity_name !== null") 參加event：{{ reservation.activity_name }} ({{ reservation.experience === 0 ? '到店體驗' : '線上體驗' }})
              small(v-else) 服務內容：
          .col-12.mb-2
            .d-flex.align-items-center
              i.fas.fa-mobile-alt.mr-2
              small 預約手機：{{ reservation.reserve_mobile ? reservation.reserve_mobile : '' }}
          .col-6.mb-2
            .d-flex.align-items-center
              i.fas.fa-users.mr-2
              small 參與人數：{{ reservation.companion_number }}
          .col-12.mb-2
            .d-flex.align-items-center
              i.fas.fa-clipboard.mr-2.flex-wrap
              small 客戶備註： {{ reservation.m_note }}
          //- .col-12.mb-2(
          //-   v-if="reservation.status === 'reserving'"
          //- )
          //-   .d-flex.align-items-center
          //-     i.far.fa-clipboard.mr-2
          //-     small.word-break-keep-all 指派其它SP：
          //-     b-form-select(
          //-       id="sp",
          //-       required,
          //-       v-model="assignSP",
          //-       placeholder="請選擇指派SP",
          //-       @change="selectAssignSPHandler(reservation.reservation_id)",
          //-       v-if="editMode.indexOf(reservation) !== -1"
          //-     )
          //-       template(
          //-         v-slot:first
          //-       )
          //-         b-form-select-option(
          //-           :value="null",
          //-           disabled
          //-         ) 請選擇指派SP
          //-       b-form-select-option(
          //-         v-for="sp in assignSpList",
          //-         :key="sp.personnel_id",
          //-         :value="sp.personnel_id"
          //-       ) {{ sp.personnel_name }}
          //-     b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-1.button.iconBtn.iconEditBtn(
          //-       variant="primary",
          //-       @click="assignSPHandler(reservation)",
          //-       width="10",
          //-       height="10",
          //-       v-if="editMode.indexOf(reservation) === -1"
          //-     )
          //-       i.fas.fa-pencil-alt.iconEdit.fa-sm
          //-     b-button.rounded-50.d-flex.align-items-center.justify-content-center.mx-1.button.iconBtn.iconCrossBtn(
          //-       variant="primary",
          //-       @click="closeAssignSPHandler(reservation)",
          //-       width="15",
          //-       height="15",
          //-       v-if="editMode.indexOf(reservation) !== -1"
          //-     )
          //-       i.far.fa-times-circle.fa-sm
          .col-12.mb-2
            .labelRow.d-flex.align-items-center.flex-wrap.mb-3
              i.fas.fa-tag.mr-2
              small 客戶標籤：
              b-badge.m-1.rounded-0.p-1(
                variant="primary",
                v-for="(label,index) in reservation.personnel_tags"
                :key="index"
              ) {{ label }}
        b-row(
          no-gutters,
          v-if="nowSelect === 'reserving' || nowSelect === 'checked'"
        )
          b-col(
            :cols="reservation.status === 'reserving' ? 3 : 4"
          )
            b-button(
              block,
              variant="primary",
              @click="cancelReservationHandler(reservation)",
              class="rounded-0 border border-black"
            ) 取消預約
          b-col(
            :cols="reservation.status === 'reserving' ? 3 : 4"
          )
            b-button(
              block,
              variant="primary",
              @click="editReservationHandler(reservation)",
              class="rounded-0 border border-black"
              v-if="reservation.reserve_type_name !== null"
            ) 修改預約
            b-button(
              block,
              variant="primary",
              @click="editEventReservationHandler(reservation)"
              class="rounded-0 border border-black"
              v-if="reservation.activity_name !== null"
            ) 修改預約
          b-col(
            cols=3,
            v-if="reservation.status === 'reserving'"
          )
            b-button(
              block,
              variant="primary",
              @click="confirmReservationHandler(reservation)",
              class="rounded-0 border border-black"
            ) 完成預約
          b-col(
            cols=3,
            v-if="reservation.status === 'reserving'"
          )
            b-button(
              block,
              variant="primary",
              class="rounded-0 border border-black",
              @click="backReservationHandler(reservation.reservation_id)"
            ) 轉派店長
          b-col(
            cols=4,
            v-if="reservation.status === 'checking' || reservation.status === 'checked'"
          )
            b-button(
              block,
              variant="primary",
              @click="doneReservationHandler(reservation)",
              class="rounded-0 border border-black"
            ) 到店諮詢
    infinite-loading(
      @infinite="infiniteHandler",
      :identifier="infiniteId",
      spinner="bubbles"
    )
      .cursor-default(slot="no-more") 無更多資料
      .cursor-default(slot="no-results") 無更多資料
      .cursor-default(slot="error") 發生錯誤，請重整重試一次

    personnelScheduleModel(
      :canChangeDate="true",
      ref="personnelScheduleRef",
      @scrollToTarget="scrollToTarget"
    )
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import personnelScheduleModel from '@/components/customerModel/personnelScheduleModel.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { SM_RESERVATION_EDIT } from '@/router/sm/reservation';
import { SM_EVENT_ACTIVITY_RESERVATION_EDIT } from '@/router/sm/event-activity';
import $ from 'jquery';

// Icon
import IconClendartUrl from '@/assets/images/icon/icon_calendar.png';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'ReservationIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading,
    personnelScheduleModel
  },
  data() {
    return {
      iconUrl: {
        IconClendartUrl
      },
      searchInput: {
        customer_name: null,
        reservation_date: null
      },
      nowSelect: 'reserving',
      infiniteId: +new Date(),
      windowScrollHeight: 0, // 視窗原本位置
      editMode: [],
      assignSP: null,
      customerData: {
        user: {},
        filter_type: ''
      },
      typeOption: [
        {
          id: '0',
          title: 'store'
        },
        {
          id: '1',
          title: 'event'
        }
      ],
      selectType: {
        id: '0',
        title: 'store'
      }
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '請稍候，\n載入中',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('sm_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('sm_reservation/getReservationTimeListHandler');
  },
  methods: {
    first_name(user) {
      if (user.created_by === 'USER') {
        return user.reserve_last_name + user.reserve_first_name;
      }
      if (user.customer_chinese_last_name && user.customer_chinese_first_name) {
        return user.customer_chinese_last_name + user.customer_chinese_first_name;
      }
      return user.line_name;
    },
    timeFormat(date) {
      return moment(date).format('HH:mm');
    },
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('sm_reservation/getReservationHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        status: vm.nowSelect,
        customer_name: vm.searchInput.customer_name,
        reservation_date: vm.searchInput.reservation_date,
        event_type: vm.selectType.id
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'reserving':
          if (vm.nowSelect === 'reserving') return;
          vm.nowSelect = 'reserving';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checked':
          if (vm.nowSelect === 'checked') return;
          vm.nowSelect = 'checked';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'success':
          if (vm.nowSelect === 'success') return;
          vm.nowSelect = 'success';
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          vm.$store.commit('sm_my_customer/resetHandler');
          vm.infiniteId += 1;
          break;
      }
    },
    cancelReservationHandler(reservation) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n取消預約中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/deleteHandler', {
        reservation_id: reservation.reservation_id
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '取消確認成功');
        });
    },
    editReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SM_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          editInfo: reservation
        }
      });
    },
    editEventReservationHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: SM_EVENT_ACTIVITY_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
        }
      });
    },
    confirmReservationHandler(reservation) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n完成預約中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/checkHandler', {
        reservation_id: reservation.reservation_id
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '完成預約成功');
        });
    },
    doneReservationHandler(reservation) {
      const vm = this;
      vm.$swal.fire({
        title: '請稍候，\n完成到店諮詢中',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sm_reservation/successHandler', {
        reservation_id: reservation.reservation_id
      })
        .then(() => {
          vm.$swal.close();
          vm.$store.commit('sm_reservation/resetHandler');
          vm.infiniteId += 1;
          vm.$snotify.success(null, '到店諮詢成功');
        });
    },
    searchHandler() {
      const vm = this;
      if (!vm.searchInput.customer_name && !vm.searchInput.reservation_date) return;
      vm.$store.commit('sm_reservation/resetHandler');
      vm.infiniteId += 1;
    },
    researtSearchHandler() {
      const vm = this;
      vm.searchInput.customer_name = null;
      vm.searchInput.reservation_date = null;
      vm.$store.commit('sm_reservation/resetHandler');
      vm.infiniteId += 1;
    },
    // 打開班表彈窗
    async openScheduleModalHandler() {
      const vm = this;
      vm.windowScrollHeight = $('html').scrollTop();
      await vm.scrollToTop();
      vm.$EventBus.$emit('openPersonnelScheduleModel', {
        store_id: vm.smData.stores[0].id
      });
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve) => {
        if ($('html').scrollTop() === 0) {
          resolve();
        } else {
          $('html').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('html').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve) => {
        $('html').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('html').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    assignSPHandler(reservation) {
      const vm = this;
      vm.assignSP = null;
      vm.editMode = [];
      if (vm.editMode.indexOf(reservation) === -1) {
        vm.editMode.push(reservation);
        vm.$swal.fire({
          title: '請稍候，\n取得可指派CA中',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        vm.$store.dispatch('sm_reservation/getAssignSpDropdownHandler', {
          store_id: vm.saData.stores[0].id,
          reserve_date: reservation.reserve_date,
          reservation_period_id: reservation.reservation_period_id
        })
          .then(() => {
            vm.$swal.close();
          });
      }
    },
    closeAssignSPHandler(reservation) {
      const vm = this;
      vm.assignSP = null;
      vm.editMode = [];
      if (vm.editMode.indexOf(reservation) !== -1) {
        vm.editMode.splice(vm.editMode.indexOf(reservation), 1);
      }
    },
    selectAssignSPHandler(reservation_id) {
      const vm = this;
      if (!vm.assignSP) return;
      const assignSPKey = _.findKey(vm.assignSpList, (val) => val.personnel_id === vm.assignSP);

      vm.$swal.fire({
        title: '您確定指派預約？',
        html: `將指派此預約給CA <span style="color: #d33">${vm.assignSpList[assignSPKey].personnel_name}</span>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '請稍候，\n指派CA中',
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sm_reservation/assignReservationHandler', {
            reservation_id,
            personnel_id: vm.assignSP
          })
            .then(() => {
              vm.$snotify.success(null, '指派成功');
              vm.$swal.close();
              vm.assignSP = null;
              vm.editMode = [];
              vm.$store.commit('sm_reservation/resetHandler');
              vm.infiniteId += 1;
            });
        } else {
          vm.assignSP = null;
        }
      });
    },
    backReservationHandler(reservation_id) {
      const vm = this;

      vm.$swal.fire({
        title: '您確定轉派預約？',
        text: '將此預約轉派回店長',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary px-5'
        }
      }).then((result) => {
        if (result.value) {
          vm.$swal.fire({
            title: '請稍候，\n轉派店長中',
            allowOutsideClick: false,
            willOpen: () => {
              this.$swal.showLoading();
            }
          });

          vm.$store.dispatch('sm_reservation/backReservationHandler', {
            reservation_id
          })
            .then(() => {
              vm.$snotify.success(null, '轉派店長成功');
              vm.$swal.close();
              vm.$store.commit('sa_reservation/resetHandler');
              vm.infiniteId += 1;
            });
        } else {
          vm.assignSP = null;
        }
      });
    }
  },
  computed: {
    ...mapState({
      smData: (state) => state.sm.smData,
      reservations: (state) => state.sm_reservation.reservations,
      reservationTimeList: (state) => state.sm_reservation.reservationTimeList,
      pagination: (state) => state.sm_reservation.pagination,
      assignSpList: (state) => state.sm_reservation.assignSp,
      TRList: (state) => state.sa.TRList,
      genderList: (state) => state.sa.genderList,
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}
</style>
